import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';
import { RevokeReservationDialogComponent } from './revoke-reservation-dialog.component';
import { WsUiModule } from '@web/util/ws-ui/ws-ui.module';

@NgModule({
  declarations: [RevokeReservationDialogComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    TranslateModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    FormsModule,
    WsUiModule
  ],
  exports: [RevokeReservationDialogComponent]
})
export class RevokeReservationDialogModule { }
